import { styled } from "@lib/components";
import { Link } from "../../../components/router/Link";

export const AuthHeading = styled("h1")`
	font-size: 24px;
	font-weight: 600;
	color: #000000;
	margin: 0;
	line-height: 34px;
`;

export const AuthSubheading = styled("p")`
	font-size: 14px;
	font-weight: 400;
	color: #000000;
	margin: 4px 0 0;
	line-height: 24px;
`;

export const AuthIntro = styled("div")`
	display: flex;
	flex-direction: column;
	gap: 0;
	width: 100%;
`;

export const FormStack = styled("div")`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
`;

export const FormField = styled("div")`
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
`;

export const FormLabel = styled("label")`
	display: block;
	font-size: 14px;
	font-weight: 600;
	color: #4b4f5e;
	line-height: 24px;
	margin: 0;
`;

export const FormLabelRow = styled("div")`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`;

export const InputWrap = styled("div")`
	position: relative;
	width: 100%;
`;

export const LeadingIcon = styled("span")`
	pointer-events: none;
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #6b7270;
	width: 24px;
	height: 24px;

	svg {
		width: 24px;
		height: 24px;
	}
`;

export const FormInput = styled("input")<{ hasLeadingIcon?: boolean; hasTrailingIcon?: boolean }>`
	width: 100%;
	box-sizing: border-box;
	height: 52px;
	padding: 12px;
	padding-left: ${(props) => (props.hasLeadingIcon ? "44px" : "12px")};
	padding-right: ${(props) => (props.hasTrailingIcon ? "40px" : "12px")};
	font-size: 16px;
	line-height: 24px;
	color: #0f172a;
	background: #fefefe;
	border: 1px solid #dfdfdf;
	border-radius: 4px;
	transition: border-color 0.15s, box-shadow 0.15s;

	&::placeholder {
		color: #6b7270;
	}

	&:focus {
		outline: none;
		border-color: ${(props) => props.theme.colors.primary};
		box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary}66;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const PasswordField = styled("div")`
	position: relative;
	width: 100%;
`;

export const ForgotLink = styled(Link)`
	font-size: 14px;
	font-weight: 700;
	color: ${(props) => props.theme.colors.primary};
	text-decoration: underline;
	text-underline-offset: 2px;

	&:hover {
		opacity: 0.85;
	}
`;

export const SubmitButton = styled("button")`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 100%;
	height: 56px;
	margin-top: 0;
	padding: 0 16px;
	font-size: 16px;
	font-weight: 700;
	color: white;
	background: ${(props) => props.theme.colors.primary};
	border: none;
	border-radius: 4px;
	cursor: pointer;
	box-shadow: 0px 10px 18px rgba(225, 29, 72, 0.3);
	transition: opacity 0.15s;

	&:hover:not(:disabled) {
		opacity: 0.9;
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px white, 0 0 0 4px ${(props) => props.theme.colors.primary},
			0px 10px 18px rgba(225, 29, 72, 0.3);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const FooterLinks = styled("div")`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 0;
	font-size: 16px;
	line-height: 24px;
	color: #4b4f5e;

	p {
		margin: 0;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		align-items: flex-start;
	}

	a {
		color: ${(props) => props.theme.colors.primary};
		font-weight: 700;
		text-decoration: underline;
		text-underline-offset: 2px;

		&:hover {
			opacity: 0.85;
		}
	}
`;

export const TestEnvLabel = styled("div")`
	margin-top: 0;
	text-align: center;
	font-size: 14px;
	color: #64748b;
`;

export const InfoText = styled("p")`
	margin: 0;
	font-size: 14px;
	line-height: 1.5;
	color: #4b4f5e;
	text-align: left;
`;

export const TermsField = styled("label")`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	margin: 0;
	font-size: 14px;
	line-height: 1.5;
	color: #4b4f5e;
	cursor: pointer;

	input {
		width: 16px;
		height: 16px;
		margin-top: 2px;
		flex-shrink: 0;
		accent-color: ${(props) => props.theme.colors.primary};
	}

	a {
		color: ${(props) => props.theme.colors.primary};
	}
`;
